(function ($) {
    /**
     * Remove tax from a value at a specific rate and return the ex-vat
     * amount
     *
     * @param amount
     * @param rate
     * @return float
     */
    const removeTax  = function (amount, rate) {
        let rateDecimal = ((rate / 100) + 1);
        let exVat = amount / rateDecimal;

        return Math.round(exVat * 100) / 100;
    }

    $(document).ready(function() {
        // Currency element
        const elmCurrencyNode = $('#product-price-inc-vat bdi span').clone();

        // Get default tax rate from data attribute
        let defaultTaxRate = Number($('#product-price-inc-vat').data('default-tax-rate'));

        // Price elements
        const elmPriceExVat = $('#product-price-ex-vat bdi');
        const elmPriceIncVat = $('#product-price-inc-vat bdi');

        // Inc vat price
        let incVatPrice = 0;

        incVatPrice = elmPriceIncVat.text();
        incVatPrice = incVatPrice.substring(1);

        // Exc vat price
        let exVatPrice = 0;

        exVatPrice = elmPriceExVat.text();
        exVatPrice = exVatPrice.substring(1);

        const defaultPriceIncVat = Number(incVatPrice);

        const applyBulkDiscountIncVat = function(amount)
        {
            let mainElm = $('#product-price-inc-vat');
            let threshold = parseInt(mainElm.data('bulk-discount-threshold'));
            let allowableSizes = mainElm.data('bulk-discount-allowable-sizes');
            let productSizes = mainElm.data('bulk-discount-sizes');
            let quantity = parseInt($('form.cart .qty').val());

            // Check if we should apply a bulk discount
            let applyBulkDiscount = false;
            for(let i in productSizes) {
                if (productSizes[i].includes(allowableSizes)) {
                    applyBulkDiscount = true;
                }
            }

            if (!applyBulkDiscount) {
                return amount;
            }

            // No modification is needed for Inc VAT when trade or threshold
            // not met
            if (quantity < threshold) {
                return amount;
            }

            // Get the tax rate selector
            // Get the tax rate selector
            let selectedTaxRate = $('.tax-selector option:selected').data('rate');

            // Tax rate selector does not always exist
            if (selectedTaxRate === undefined) {
                selectedTaxRate = defaultTaxRate;
            } else {
                selectedTaxRate = Number(selectedTaxRate);
            }

            // Get the discount value
            const discount = parseFloat(mainElm.data('bulk-discount-amount'));

            return amount - (discount * quantity);
        }

        /**
         * Re-calculate prices when the quantity or tax rate changes
         */
        $('form.cart .qty, form.cart .tax-selector').bind('input', function() {
            // Get the tax rate selector
            let selectedTaxRate = $('.tax-selector option:selected').data('rate');

            // Tax rate selector does not always exist
            if (selectedTaxRate === undefined) {
                selectedTaxRate = defaultTaxRate;
            } else {
                selectedTaxRate = Number(selectedTaxRate);
            }

            // Quantity
            let quantity = parseInt($('form.cart .qty').val());

            // Set a default quantity of 1 if non-numeric
            if (typeof quantity !== 'number') {
                quantity = 1;
            }

            /**
             * Prices are entered in Woo inclusive of VAT. When working with the
             * default tax rate, we will work out the ex-vat price from the
             * inc-vat price to give us a value that isn't rounded, so we can
             * match the WooCommerce way of calculating ex-VAT prices
             */
            if (selectedTaxRate === defaultTaxRate) {

                // Update the inc-VAT price
                let incVatSubtotal = applyBulkDiscountIncVat(defaultPriceIncVat * quantity);
                elmPriceIncVat.html(incVatSubtotal.toFixed(2));
                elmPriceIncVat.prepend(elmCurrencyNode.clone());

                // Calculate ex vat price (using inc VAT price) for best
                // rounding accuracy
                if (elmPriceExVat.length > 0) {
                    // Remove the tax from the subtotal
                    let exVatSubtotal = removeTax(applyBulkDiscountIncVat(defaultPriceIncVat * quantity), defaultTaxRate);
                    elmPriceExVat.html(exVatSubtotal.toFixed(2));
                    elmPriceExVat.prepend(elmCurrencyNode.clone());
                }
            } else {
                /**
                 * Prices are entered in Woo inclusive of VAT at the default
                 * rate. When using a VAT rate that is not the default, we need
                 * to find the ex-VAT rice in order to apply the new rate
                 */
                // Calculate ex-VAT
                let exVatSubtotal = removeTax(incVatPrice * quantity, defaultTaxRate);

                // Get the inc VAT price with the new tax rate applied
                let incVatSubtotal = applyBulkDiscountIncVat(exVatSubtotal + (exVatSubtotal / 100) * selectedTaxRate);

                // Now we can work out the exVAT price again,
                exVatSubtotal = removeTax(incVatSubtotal, selectedTaxRate);

                elmPriceExVat.html(exVatSubtotal.toFixed(2));
                elmPriceExVat.prepend(elmCurrencyNode.clone());

                elmPriceIncVat.html(incVatSubtotal.toFixed(2));
                elmPriceIncVat.prepend(elmCurrencyNode.clone());
            }

            // Update the offer panel style
            let mainElm = $('#product-price-inc-vat');
            let threshold = parseInt(mainElm.data('bulk-discount-threshold'));

            if (quantity >= threshold) {
                $('.product__offer').addClass('product__offer--complete');
            } else {
                $('.product__offer').removeClass('product__offer--complete');
            }
        });
    });
})(jQuery);